import qs from 'qs';

let instance = null;

class API {
  constructor(url) {
    if (!instance) {
      instance = this;
    }

    this.url = url || process.env.REACT_APP_API_URL;

    return instance;
  }

  setUrl(url) {
    this.url = url;
  }

  /*async*/ getImgorShopifyGearProductsByCollection(isAdult) {
    var path = `${this.url}/catalog/gear/shopify`;
    if(isAdult === true) {
      path = `${this.url}/catalog/gear/shopify/adult`;
    }
    fetch(path)
    .then((res) => res.json())
    .then(
      (result) => {
        console.log('isAdult', isAdult);
        console.log('GEAR PRODUCTS', result);
        window.gear_products = result;
        return result;
      },
      (error) => {
        console.error(`Get gears product data failed, try again`);
      }
    );
    /*
    const res = await fetch(path);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Update cart participant failed with ${res.status}`);
    }
    */
  }

  async createCart() {
    const res = await fetch(`${this.url}/cart`, {
      method: 'post',
    });
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Create cart failed with ${res.status}`);
    }
  }

  /*
    data: {
      representative_email: string
      representative_data: string
      contact_number: string
      email: string
      first_name: string
      last_name: string
      push_status: 0
      status: 1
      representative_data: string
      representative_email: string
    }
  */
  async updateCart(id, data) {
    const res = await fetch(`${this.url}/cart/${id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Update cart failed with ${res.status}`);
    }
  }

  async addParticipant(cartId, { email, gender, age }) {
    const res = await fetch(`${this.url}/cart/${cartId}/participant`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        gender,
        age,
      }),
    });
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Add participant failed with ${res.status}`);
    }
  }

  /*
    data: {
      age: string
      dob: timestamp
      email: "host@test.com"
      first_name: string
      gender: string eg. male|female
      last_name: string
      phone: string
      position: string eg. "8872B792-B80C-E811-80E0-001DD8B71D85"
      preferred_shirt_size: string eg. "xs" "l"..
    }
  */
  async updateCartParticipant(id, participantId, data) {
    const res = await fetch(
      `${this.url}/cart/${id}/participant/${participantId}`,
      {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Update cart participant failed with ${res.status}`);
    }
  }

  /*
    @params group_by:age_from,age_to,boarding
    @params business_type:Youth+Camp
    @params sport:Tennis|Golf
  */
  async fetchHistogram(params) {
    console.log('getHistogram', `${this.url}/catalog/camps/histogram?${qs.stringify(params)}`);
    const res = await fetch(
      `${this.url}/catalog/camps/histogram?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch histogram failed with ${res.status}`);
    }
  }

  /*
    @params boarding:true|false
    @params business_type:Youth+Camp
    @params gender:Male|Female
    @params package_type:Sport
    @params sport:Tennis|Golf
    @params refundable:true|false
  */

  async fetchSeasons(params) {
    const res = await fetch(
      `${this.url}/catalog/camps/seasons?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch camps failed with ${res.status}`);
    }
  }

  async fetchCalendar(params) {
    console.log('getCalendar', `${this.url}/catalog/camps/calendar?${qs.stringify(params)}`);
    const res = await fetch(
      `${this.url}/catalog/camps/calendar?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch calendar failed with ${res.status}`);
    }
  }

  async fetchCalendarFilter(params) {
    console.log('getCalendarFilter', `${this.url}/catalog/camps/calendar/filter?${qs.stringify(params)}`);
    const res = await fetch(
      `${this.url}/catalog/camps/calendar/filter?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch calendar failed with ${res.status}`);
    }
  }

  async fetchCamp(id, isBundle) {
    const res = await fetch(
      `${this.url}/catalog/camp/${id}?bundle=${isBundle}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch camp failed with ${res.status}`);
    }
  }

  /*
    @params boarding:true|false
    @params business_type:Youth+Camp
    @params gender:Male|Female
    @params package_type:Sport
    @params sport:Tennis|Golf
  */

  async fetchCamps(params) {
    const res = await fetch(
      `${this.url}/catalog/camps?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch camps failed with ${res.status}`);
    }
  }

  /*
    @params boarding:yes|no
    @params business_type:Youth+Camp
    @params gender:Male|Female
    @params package_type:Sport
    @params sport:Tennis|Golf
  */

  async fetchConcentrations(params) {
    console.log('getConcentrations', `${this.url}/catalog/camps/concentrations?${qs.stringify(params)}`);
    const res = await fetch(
      `${this.url}/catalog/camps/concentrations?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch concentrations failed with ${res.status}`);
    }
  }

  async fetchPositions(sport) {
    const res = await fetch(`${this.url}/catalog/positions?sport=${sport}`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch positions failed with ${res.status}`);
    }
  }

  async fetchSizes(gender) {
    const res = await fetch(`${this.url}/catalog/sizes?gender=${gender}`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch sizes failed with ${res.status}`);
    }
  }

  async fetchTransport() {
    const res = await fetch(`${this.url}/catalog/transport`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch transport failed with ${res.status}`);
    }
  }

  async fetchTransportUnaccompannied() {
    const res = await fetch(`${this.url}/catalog/transport/unaccompanied`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch transport unaccompanied failed with ${res.status}`);
    }
  }

  async fetchTransportUnaccompanniedInternational() {
    const res = await fetch(`${this.url}/catalog/transport/unaccompanied/international`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch transport unaccompanied failed with ${res.status}`);
    }
  }

  async fetchAirlines() {
    const res = await fetch(`${this.url}/catalog/airlines`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch airlines failed with ${res.status}`);
    }
  }

  getShopifyProductInfo(url, product_id, quantity, type) {
    if(type === 'shopify_gear'){
      var shopify_products_list_out = [];
      var shopify_product = {};
      shopify_product.quantity = quantity;
      shopify_product.product_type = type;
      shopify_product.type_key = type;
      shopify_product.product_id = product_id;
      shopify_product.shopify_id = product_id;
      shopify_product.id = url.id;
      shopify_products_list_out.push(shopify_product);
      var shopify_products = window.newcart.products;
      shopify_products.push(shopify_products_list_out);
      window.newcart.products = shopify_products;
    } else {
      fetch(`${url}/catalog/shopify/${product_id}`)
      .then((res) => res.json())
      .then(
        (result) => {
          const shopify_products_list = result.results;
          if(shopify_products_list){
            console.log('shopify_products_list:', shopify_products_list);
            var shopify_products_list_out = [];
            for (let shopify_products of shopify_products_list) {
              shopify_products.quantity = quantity;
              shopify_products.product_type = type;
              shopify_products.product_id = product_id;
              shopify_products_list_out.push(shopify_products);
            }
            var shopify_products = window.newcart.products;
            shopify_products.push(shopify_products_list_out);
            window.newcart.products = shopify_products;
          } else {
            console.error(`Get product data failed, try again`);
            this.getShopifyProductInfo(url, product_id, quantity, type);
          }
        },
        (error) => {
          console.error(`Get product data failed, try again`);
          this.getShopifyProductInfo(url, product_id, quantity, type);
        }
      );
    }
  };

  async addProductToCart(
    cartId,
    participantId,
    { attributes = [], product, quantity = 1, price, type, refundable = false }
  ) {

    console.log('addProductToCart', product);

    //var fvaoverlay = document.getElementById('fvaoverlay');
    //fvaoverlay.style.display = 'block';

    if(type === "gear-upsell" || type === "excursion" || (type === "gear" && price === undefined)) {
      price = product.capacity_price;
      product.price = price;
    }

    if(price === undefined && product.capacity_price) {
      price = product.capacity_price;
      product.price = price;
    }

    const datacheck = {
      attributes,
      product,
      type,
      quantity,
      refundable,
      price,
      product_id: product.id,
      participantId: participantId,
    };

    console.log('Check product1:', datacheck);
    console.log('Check product2:', `${this.url}/catalog/shopify/${product.id}`);

    /*
    const res = await fetch(
      `${this.url}/catalog/shopify/${product.id}`
    );
    const result = await res.json();
    console.log('Result:', result);
    const shopify_products_list = result.results;
    var shopify_products_list_out = [];
    for (let shopify_products of shopify_products_list) {
      shopify_products.quantity = quantity;
      shopify_products.product_type = type;
      shopify_products.product_id = product.id;
      shopify_products_list_out.push(shopify_products);
    }
    var shopify_products = window.newcart.products;
    shopify_products.push(shopify_products_list_out);
    window.newcart.products = shopify_products;
    */

    if(type === 'shopify_gear'){
      console.log('Gear attributes:', attributes);
      this.getShopifyProductInfo(product, attributes[0].selectedVariant, quantity, type);
      for (let option of product.gear_options.options) {
        if(`${option.id}` === attributes[0].selectedVariant){
          product.price = option.price;
        }
        if(option.suboptions){
          for (let suboption of option.suboptions.options) {
            if(`${suboption.id}` === attributes[0].selectedVariant){
              product.price = suboption.price;
            }
            if(suboption.suboptions){
              for (let subsuboption of suboption.suboptions.options) {
                if(`${subsuboption.id}` === attributes[0].selectedVariant){
                  product.price = subsuboption.price;
                }
              }
            }
          }
        }
      }
    } else {
      this.getShopifyProductInfo(this.url, product.id, quantity, type);
    }

    /*
    fetch(`${this.url}/catalog/shopify/${product.id}`)
    .then((res) => res.json())
    .then(
      (result) => {
        const shopify_products_list = result.results;
        console.log('shopify_products_list:', shopify_products_list);
        var shopify_products_list_out = [];
        for (let shopify_products of shopify_products_list) {
          shopify_products.quantity = quantity;
          shopify_products.product_type = type;
          shopify_products.product_id = product.id;
          shopify_products_list_out.push(shopify_products);
        }
        var shopify_products = window.newcart.products;
        shopify_products.push(shopify_products_list_out);
        window.newcart.products = shopify_products;
      },
      (error) => {
        console.error(`Get product data failed`);
      }
    );
    */

    var products = window.newcart.cart.participants[0].products;
    var new_product = {
        "id": product.id,
        "product": product,
        "quantity": quantity,
        "refundable": refundable,
        "attributes": attributes,
        "type": type,
        "price": product.price,
        "position": null
    };
    if(refundable === 'Flexible' && product.price_flexible){
      new_product.price = product.price_flexible;
    } else if (refundable === 'Refundable' && product.price_refundable){
      new_product.price = product.price_refundable;
    } else {
      new_product.price = product.price;
    }
    products.push(new_product);
    window.newcart.cart.participants[0].products = products;
    window.newcart.participant_product_id = product.id;
    window.newcart.cart.quantity = window.newcart.cart.quantity + quantity;
    window.newcart.cart.price_total = window.newcart.cart.price_total + (new_product.price * quantity);
    console.log('Product added: ', window.newcart);

    //fvaoverlay.style.display = 'none';

    return window.newcart;


    /*
    await fetch(`${this.url}/catalog/shopify/${product.id}`)
    .then((res) => res.json())
    .then(
      (result) => {
        const shopify_products_list = result.results;

        var shopify_products = window.newcart.products;
        shopify_products.push(shopify_products_list);
        window.newcart.products = shopify_products;

        var products = window.newcart.cart.participants[0].products;
        var new_product = {
            "id": product.id,
            "product": product,
            "quantity": quantity,
            "refundable": false,
            "attributes": [],
            "type": type,
            "price": product.price,
            "position": null
        };
        products.push(new_product);
        window.newcart.cart.participants[0].products = products;
        window.newcart.participant_product_id = product.id;
        console.log('Porduct added: ', window.newcart);

        return window.newcart;
      },
      (error) => {
        console.error(`Get product data failed`);
      }
    );
    */

    /*
    fetch(`${this.url}/catalog/shopify/${product.id}`)
    .then((res) => res.json())
    .then(
      (result) => {
        const shopify_products_list = result.results;
        shopify_products_list.forEach(item => {
            // Check for non_refundable variant
            var type_key_exist = false;
            const type_key = item.type_key;
            if(type_key.indexOf('airport_') !== -1) type_key_exist = true;
            if(item.type_key === "non_refundable" || item.type_key === "attribute" || type_key_exist){
              console.log('Product found:', item.shopify_id);
              console.log('Product:', item);

              // Add product to cart
              let formData = {
               'items': [{
                'id': item.shopify_id,
                'quantity': quantity,
                'participant_id': participantId,
                }]
              };

              // Add this data to Camp Line Item: https://git.largeinc.com/img/imgor-shopify-theming/-/blob/master/custom/src/order-review/mapping/participant.js#L57
              if(type === 'camp'){

              }

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                console.log('Product added to cart:', item.shopify_id);
                console.log('Product added to cart info:', response);
              })
              .catch((error) => {
                console.error('Error add to cart:', error);
              });

            }
        });
      },
      (error) => {
        console.error(`Get product data failed`);
      }
    );
    */

    /*
    const res = await fetch(
      `${this.url}/cart/${cartId}/participant/${participantId}/product`,
      {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes,
          product,
          type,
          quantity,
          refundable,
          price,
          product_id: product.id,
        }),
      }
    );

    if (res.ok) {
      console.log('Check what is return');
      return res.json();
    } else {
      console.error(`Add product failed with ${res.status}`);
    }
    */

  }

  async removeProductFromCart(cartId, participantId, productId/*, shopify_productId*/) {

    var products = window.newcart.cart.participants[0].products;
    var new_products = [];
    for (let product of products) {
      if(product.id === productId){
        // Do not add
      } else {
        new_products.push(product);
      }
    }
    window.newcart.cart.participants[0].products = new_products;

    console.log('Remove product', productId);
    console.log('New products', new_products);

    var shopify_products = window.newcart.products;
    var new_shopify_products = [];
    for (let shopify_product of shopify_products) {
      var remove_this = false;
      for (let item of shopify_product) {
        if(item.product_id === productId) {
          remove_this = true;
        }
        if(item.id === productId) {
          remove_this = true;
        }
      }
      if(!remove_this){
        new_shopify_products.push(shopify_product);
      }
    }
    window.newcart.products = new_shopify_products;

    const cart_products = window.newcart.cart.participants[0].products;
    var price_total = 0;
    cart_products.forEach(item => {
      price_total = price_total + (item.product.price * item.quantity);
    });
    window.newcart.cart.price_total = price_total;

    return window.newcart;


    /*
    const res = await fetch(
      `${this.url}/cart/${cartId}/participant/${participantId}/product/${productId}`,
      {
        method: 'delete',
      }
    );

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Remove product failed with ${res.status}`);
    }
    */

    /*
    console.log('Check product:', `${this.url}/catalog/shopify/${shopify_productId}`);
    fetch(`${this.url}/catalog/shopify/${shopify_productId}`)
    .then((res) => res.json())
    .then(
      (result) => {
        const shopify_products_list = result.results;
        shopify_products_list.forEach(item => {
            // Check for non_refundable variant
            var type_key_exist = false;
            const type_key = item.type_key;
            if(type_key.indexOf('airport_') !== -1) type_key_exist = true;
            if(item.type_key === "non_refundable" || item.type_key === "attribute" || type_key_exist){
              console.log('Product found:', item.shopify_id);
              console.log('Product:', item);

              // Delete product from cart
              let formData = {
                'id': item.shopify_id,
                'quantity': 0
              };
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                console.log('Product deleted from cart:', item.shopify_id);
              })
              .catch((error) => {
                console.error('Error delete from cart:', error);
              });

            }
        });
      },
      (error) => {
        console.error(`Delete product data failed`);
      }
    );
    */

  }

  async calculateCartRefundable(cartId) {

    // res.total_price_difference
    console.log('calculateCartRefundable:', cartId);

    var exres = {};
    exres.total_price_difference = 0;
    const products = window.newcart.cart.participants[0].products;
    console.log('calculateCartRefundable1:', products);
    products.forEach(item => {
      console.log('calculateCartRefundable item:', item);
      if(item.product.price_refundable && item.product.price){
        exres.total_price_difference = exres.total_price_difference + ((item.product.price_refundable - item.product.price)*item.quantity);
      }
    });
    return exres;

    /*
    const res = await fetch(`${this.url}/cart/${cartId}/refundable/calculate`, {
      method: 'get',
    });

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Calculate cart refundable failed with ${res.status}`);
    }
    */
  }

  async getCart(cartId) {
    const res = await fetch(`${this.url}/cart/${cartId}`, {
      method: 'get',
    });

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Get cart failed with ${res.status}`);
    }
  }

  async getShopifyCart() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'get',
    });

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Get cart failed with ${res.status}`);
    }
  }

  async setShopifyPromocode(promocode) {
    await fetch(window.Shopify.routes.root + 'discount/' + promocode, {
      method: 'get',
    });
  }

  async updateCartRefundable(cartId, value) {
    const res = await fetch(
      `${this.url}/cart/${cartId}/refundable/process/${value}`,
      {
        method: 'get',
      }
    );

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Update cart refundable failed with ${res.status}`);
    }
  }

  /*
    @params start_date:string
    @params end_date:string
    @params age:string
  */
  async fetchExcursions(params) {
    if (!params.start_date || !params.end_date) {
      throw new Error('Fetching excursions is missing required params');
    }

    const res = await fetch(
      `${this.url}/catalog/excursions-new?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch excursions failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params age:string
  */
  async fetchGear(params) {
    if (!params.gender || !params.age) {
      throw new Error('Fetching gear is missing required params');
    }

    const res = await fetch(`${this.url}/catalog/gear?${qs.stringify(params)}`);
    if (res.ok) {
      //console.log('fetchGear:', res.json());
      return res.json();
    } else {
      console.error(`Fetch gear failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params age:string
  */
  async fetchEssentials(params) {
    const res = await fetch(
      `${this.url}/catalog/essentials?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch essentials failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params age:string
  */
  async fetchEarlyCheckin(params) {
    const res = await fetch(
      `${this.url}/catalog/camps/early-checkin?${qs.stringify(params)}`
    );

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch early checkin failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params age:string
  */
  async fetchPrivateBoarding(params) {
    const res = await fetch(
      `${this.url}/catalog/camps/private-boarding?${qs.stringify(params)}`
    );

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch private boarding failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params sport:string
    @params date:string
  */
  async fetchUpsell(params) {
    const res = await fetch(
      `${this.url}/catalog/gear/upsell-new?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch upsells failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params age:string
  */
  async fetchGearPackage(params) {
    const res = await fetch(
      `${this.url}/catalog/gear/bundle?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch gear packages failed with ${res.status}`);
    }
  }

  /*
    @params age:string
  */
  async fetchExcursionPackage(params) {
    const res = await fetch(
      `${this.url}/catalog/excursions/bundle?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch gear packages failed with ${res.status}`);
    }
  }

  /*
    @params gender:string
    @params age:string
  */
  async fetchEssentialsPackage(params) {
    const res = await fetch(
      `${this.url}/catalog/essentials/bundle?${qs.stringify(params)}`
    );
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Fetch gear packages failed with ${res.status}`);
    }
  }

  // Useful to save form state and enable edition later
  async setStorage(state) {
    const res = await fetch(`${this.url}/storage/set`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        key: 'state',
        value: {
          payload: JSON.stringify(state),
        },
      }),
    });

    if (res.ok) {
      const data = await res.json();
      return {
        data,
        token: res.headers.get('x-dynamic-token'),
      };
    } else {
      console.error(`Set storage failed with ${res.status}`);
    }
  }

  async getStorage(token) {
    const res = await fetch(`${this.url}/storage/get/state`, {
      headers: {
        'x-dynamic-token': token,
      },
    });

    if (res.ok) {
      return res.json();
    } else {
      console.error(`Get storage failed with ${res.status}`);
    }
  }

  async determineSize(id) {
    const res = await fetch(`${this.url}/cart/${id}/determine-size`);
    if (res.ok) {
      return res.json();
    } else {
      console.error(`Determining size failed with ${res.status}`);
    }
  }
}

export default API;
